import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';

/**
 * Hook to synchronize the Clerk user with the Sentry user context.
 * Only the opaque Clerk user id is sent: no name, username or e-mail
 * (privacy fact sheet F1). Support resolves the id in Clerk when needed.
 */
export function useSentryUserContext() {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;

    if (user) {
      Sentry.setUser({ id: user.id });
    } else {
      // Clear user context when user logs out
      Sentry.setUser(null);
    }
  }, [user, isLoaded]);
}